// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
const loadImages = require("%helpers%/load-images.js");
// -- Helpers END


// -- Libraries BEGIN
import swiper from "swiper";
// -- Libraries END


windowLoad(function() {

	const sliderData = {
		element: $(".sec-films__swiper"),
		arrows: {
			all: $(".sec-films .slider-arrows__arrow"),
			prev: $(".sec-films .slider-arrows__arrow_prev"),
			next: $(".sec-films .slider-arrows__arrow_next"),
		},
	};

	const swiperData = {
		spaceBetween: 16,
		speed: 800,
		loop: false,
		slidesPerView: 5,
		autoHeight: true,
		navigation: {
			prevEl: sliderData.arrows.prev,
			nextEl: sliderData.arrows.next,
		},
		breakpoints: {
			375: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 4,
			},
			1200: {
				slidesPerView: 5,
			},
		}
	};

	// -- Functions BEGIN
	const sliderInit = () => {
		new swiper(sliderData.element, swiperData);
	};
	// -- Functions END


	if (sliderData.element.length) sliderInit();

});

